import { EMPTY } from "rxjs";
export var pathEmpty = function () { return EMPTY; };



//////////////////
// WEBPACK FOOTER
// ./src/features/guards/pathEmpty.ts
// module id = 90
// module chunks = 3